import { queryOptions, useQuery, useQueryClient } from "@tanstack/react-query"
import { useEffect } from "react"
import { onAppActive } from "@/shared/lib/platform"
import { socialMatchKeys } from "../model/keys"
import { getSocialMatchStatus } from "./client"

export function socialMatchStatusQueryOptions(userId: number) {
	return queryOptions({
		queryKey: socialMatchKeys.status(userId),
		queryFn: () => getSocialMatchStatus(),
		staleTime: 30_000,
	})
}

export function useSocialMatchStatus(userId: number) {
	const queryClient = useQueryClient()
	const query = useQuery(socialMatchStatusQueryOptions(userId))

	useEffect(
		() =>
			onAppActive(() => {
				void queryClient.invalidateQueries({
					queryKey: socialMatchKeys.status(userId),
				})
			}),
		[queryClient, userId],
	)

	return query
}
